import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination, Hospital } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  tipoAcomodacao: boolean,
}

interface TipoAcomodacao {
  id: string | null,
  hospitalId: string,
  descricao: string | null,
  hisId: string,
  status: 'Ativo' | 'Removido',
}

@Module({ namespaced: true, name: 'SuporteTipoAcomodacaoStore' })
export default class SuporteTipoAcomodacaoStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalDefault: Hospital = {
    id: '',
    nome: '',
    utilizaTipoAcomodacaoHospital: false,
  }

  public hospital: Hospital = { ...this.hospitalDefault }
  public hospitalId: string = ''
  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    tipoAcomodacao: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setHospital(hospital: Hospital) {
    this.hospital = hospital
  }

  @Mutation
  clearHospital() {
    this.hospital = { ...this.hospitalDefault }
  }

  @Mutation
  setMode(mode: Mode) {
    this.mode = mode
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        hospital.utilizaTipoAcomocaoHospital = !!c.utilizaTipoAcomocaoHospital
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** Tipo Acomodacao */
  public paginationTipoAcomodacao: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  private tipoAcomodacaoListDefault: TipoAcomodacao[] = []
  public tipoAcomodacaoList: TipoAcomodacao[] = [...this.tipoAcomodacaoListDefault]
  private tipoAcomodacaoDefault: TipoAcomodacao = {
    id: '',
    hospitalId: '',
    hisId: '',
    descricao: '',
    status: 'Ativo',
  }

  public tipoAcomodacao: TipoAcomodacao = { ...this.tipoAcomodacaoDefault }

  public searchTipoAcomodacao: string = ''

  @Mutation
  setSearchTipoAcomodacao(value: string) {
    this.searchTipoAcomodacao = value
  }

  @Mutation
  setPaginationTiṕoAcomodacao(val: DataTablePagination) {
    this.paginationTipoAcomodacao = val
  }

  @Mutation
  setTipoAcomodacaoList(value: TipoAcomodacao[]) {
    this.tipoAcomodacaoList = value
  }

  @Mutation
  clearTiṕoAcomodacaoList() {
    this.tipoAcomodacaoList = [...this.tipoAcomodacaoListDefault]
  }

  @Mutation
  setTipoAcomodacao(value: TipoAcomodacao) {
    this.tipoAcomodacao = value
  }

  @Mutation
  clearTipoAcomodacao() {
    this.tipoAcomodacao = { ...this.tipoAcomodacaoDefault }
  }

  @Action
  async getAllTipoAcomodacaoByHospitalId(hospitalId: string) {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllTipoAcomodacaoByHospitalId(hospitalId)
      if (request.success) this.context.commit('setTipoAcomodacaoList', request.data as TipoAcomodacao[] || [])
      return request
    } catch (error) {
      this.context.commit('setTipoAcomodacaoList', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertTipoAcomodacao() {
    try {
      const params: TipoAcomodacao = this.tipoAcomodacao

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.Agendamento.SuporteApi.upsertTipoAcomodacao({ ...params, hospitalId: this.hospitalId })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
